import { companyApis } from '@apis/dashboard/companyApis';
import { dashboardCompanyApis } from '@apis/next/companyApis';
import { useMutation } from '@hooks/useMutation';
import type { PatchCompanyStaff } from '@models/User';
import { useQueryClient } from '@tanstack/react-query';
import { EmailDuplicateError } from '@utils/errors';

export const usePatchCompanyStaff = (company_id: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (props: { id: number; body: PatchCompanyStaff }) => {
      const response = await companyApis.patch('/dashboard/company/staff/{id}/', {
        path: { id: props.id },
        body: props.body,
      });
      if (response[409]) {
        throw new EmailDuplicateError(
          `${response[409]?.email_duplicate_error?.join(',')} are already in use`,
        );
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/dashboard/company/${company_id}/staff/`]);
        queryClient.invalidateQueries(
          dashboardCompanyApis.getKeyByPath('get', '/dashboard/company/:id/staff', {
            params: { id: company_id },
          }),
        );
      },
    },
  );
};
